module.exports = __webpack_public_path__ + "static/media/child.e2cfb137.svg";